import { CategoryTreeEntity } from './category-tree.models';

export function findCategoryTreeNodeById(nodes: CategoryTreeEntity[], id: number): CategoryTreeEntity | undefined {
  for (const node of nodes) {
    if (node.id === id) {
      return node;
    }
    if (node.childcategories) {
      const found = findCategoryTreeNodeById(node.childcategories, id);
      if (found) {
        return found;
      }
    }
  }
  return undefined;
}

export function collectCategoryTreeIds(node: CategoryTreeEntity): number[] {
  const ids = [node.id];
  if (node.childcategories) {
    node.childcategories.forEach((child) => ids.push(...collectCategoryTreeIds(child)));
  }
  return ids;
}

export interface CategoryTreeNavigationTarget {
  path: string;
  queryParams: Record<string, unknown>;
}

/**
 * Builds the route + query params for navigating to a category via the Kategorien tree selector,
 * preserving active filters and switching to the documents view when needed.
 */
export function buildCategoryTreeNavigationTarget(
  tree: CategoryTreeEntity[],
  id: number | null,
  currentQueryParams: Record<string, unknown>,
): CategoryTreeNavigationTarget {
  const queryParams: Record<string, unknown> = { ...currentQueryParams, page: 1 };
  // With an active filter or "Dokumentstatus", categories without own documents still show the (filtered) document list
  const hasActiveFilter = !!queryParams['filterIds'] || !!queryParams['documentType'];

  if (id == null) {
    // The category root has no id, so its filtered document list is served via /categories/documents instead
    return { path: hasActiveFilter ? '/categories/documents' : '/categories', queryParams };
  }

  const node = findCategoryTreeNodeById(tree, id);
  const path = '/categories/' + id + (node?.has_documents || hasActiveFilter ? '/documents' : '');
  return { path, queryParams };
}
